export default "__VITE_ASSET__CFPNgsmm__"